import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { PersonalizedRecommendationsFragment, Product } from 'src/types';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';
import ExpandableProductCardGrid from 'src/components/expandable-product-card-grid';
import { filterCategories } from 'src/areas/landing-page/filter-categories';

type Props = {
  products?: Recommendations['products'];
};

type Recommendations = NonNullable<
  PersonalizedRecommendationsFragment['fallbackRecommendations']
>;

const FallbackProductRecommendations: React.FC<Props> = props => {
  const { products = { nodes: [] } } = props;
  const { t, linkTo } = useContext(AppContext);

  if (!(products && products.nodes) || !products.nodes.length) {
    return null;
  }

  const productsItems = filterCategories(products.nodes as Product[]);

  const internalLinkTo = linkTo('virtualCategory', { id: 'v100' });

  const trackHeaderClick = (data: { link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.FALLBACK_RECOMMENDATIONS_HEADER,
      nextPage: data.link,
    });
  };

  const trackProductCardClick = (data: { index: number; link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.FALLBACK_RECOMMENDATIONS_PRODUCT_CARD,
      nextPage: data.link,
      index: data.index,
    });
  };

  return (
    <ExpandableProductCardGrid
      products={productsItems}
      title={t('landing', 'hot-products.title')}
      linkPath={internalLinkTo}
      linkTitle={t('common', 'button.show-more')}
      shouldLazyLoadImages
      dataTestType="product-recommendations"
      onHeaderLinkClick={trackHeaderClick}
      onProductCardClick={trackProductCardClick}
    />
  );
};

export default FallbackProductRecommendations;
